<template>
  <a :href="newsInfo.url" :click_report_50bang="newsInfo.click_report_50bang" :compName="compName" style="width: 100%;display: block;" :tag="tag" class="touch" :id="newsInfo.newsId" @click="clickReport()" target="_blank">
    <template v-if="false">
      <h2 class="news-h2">
        <div class="news-title" v-text="newsInfo.title"></div>
      </h2>
      <div class="news-imgs">
        <div class="news-img-a new-div2" v-for="(imgInfo, imgIdx) in newsInfo.miniimg" v-bind:key="imgIdx">
          <img :src="imgInfo.src" :alt="newsInfo.title"/>
        </div>
        <div class="news-img-a placeholder-img new-div2" v-show="newsInfo.showMorePos">查看更多</div>
      </div>
      <div class="news-info clearfix">
        <span class="icon_hot" v-if="newsInfo.hotnews === 1">热点</span>
        <span class="icon_tj" v-if="newsInfo.isrecom === 1">推荐</span>
        <span class="news-from" v-text="newsInfo.source"></span>
        <span class="news-date" v-text="newsInfo.timeStr"></span>
      </div>
    </template>
    <template v-if="true">
      <div class="news-imgs">
        <div class="news-img-a new-div2">
          <img :src="newsInfo.pic" class="news-img" :alt="newsInfo.title">
        </div>
      </div>
      <div class="news-content">
        <h2 class="news-h2">
          <div class="news-title" v-text="newsInfo.title"></div>
        </h2>
        <div class="news-info">
          <span class="icon_hot" v-if="newsInfo.isrecom === 1">热点</span>
          <span class="icon_tj" v-if="newsInfo.isrecom === 1">推荐</span>
          <span class="news-from" v-text="newsInfo.source"></span>
          <span class="news-date" v-text="newsInfo.timeStr"></span>
        </div>
      </div>
    </template>
  </a>
</template>
<script>
import stats from '../../api/statistics'
export default {
  name: 'NewsTplDf',
  props: ['newsInfo', 'compName', 'tag', 'pageType'],
  methods : {
    clickReport () {
      if (this.newsInfo.hasOwnProperty('click_report_50bang')) {
        stats.ajax99(this.newsInfo.click_report_50bang);
      }
    }
  }
}
</script>
